import React, { useState } from 'react';
import '../styles/login.css';
import visibilityIcon from '../assets/visibility.png';
import HiddenIcon    from '../assets/hidden.png';
import loginimage   from '../assets/Login-amico.png';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer }    from 'react-toastify';
import { handleError, handleSuccess } from '../utils';
import config from '../config/config';

export default function Signup() {
  const [signupInfo, setSignupInfo] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword]             = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setSignupInfo(prev => ({ ...prev, [name]: value }));

    if(name === "password"){
      const error = validatePassword(value);
      setPasswordError(error);
    }
    
  };

  function validatePassword(password) {
    const minLength = 8;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;
  
    if (password.length < minLength &&  !regex.test(password) ) {
      return (
        <p>
          1. Must be at least 8 characters long.<br /> 
          2. Must include uppercase, lowercase, number, and special character. 
        </p>
        
      );
    }
    if (!regex.test(password)) {
      return "Password must include uppercase, lowercase, number, and special character.";
    }
    if (password.length < minLength) {
      return "Must be at least 8 characters long.";
    }
  }
  const handleSignup = async e => {
    e.preventDefault();
    const { name, email, password, confirmPassword } = signupInfo;
    if (!name || !email || !password || !confirmPassword)
      return handleError('All fields are required');
    if (password !== confirmPassword)
      return handleError("Passwords don't match");

    const error = validatePassword(password);
    if (error) {
    setPasswordError(error);
    return handleError('Password does not meet requirements');
    }

    try {
      const res = await fetch(`${config.apiUrl}/api/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(signupInfo)
      });
      const { success, message, error } = await res.json();
      
      if (success) {
        handleSuccess(message);
        setTimeout(() => navigate('/verify-email', {
        state: { email: signupInfo.email }
      }), 500);
      } else if (error?.details) {
        const msgs = error.details.map(d => d.message).join(', ');
        handleError(msgs);
      } else {
        handleError(message);
      }
    } catch (err) {
      handleError(err.message || err);
    }
  };

  return (
    <div className='login-container'>
      <div className="form-box">
        <div className="form-left">
          {/* Toggle bar */}
          <div className="toggle-buttons">
            <Link to="/login"  className="toggle">Login</Link>
            <Link to="/signup" className="toggle active">Signup</Link>
          </div>

          <form onSubmit={handleSignup}>
            
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="name"
              placeholder="Enter your username"
              value={signupInfo.name}
              onChange={handleChange}
              autoComplete="username"
            />
            </div>

            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={signupInfo.email}
              onChange={handleChange}
              autoComplete="email"
            />

            <label htmlFor="password">Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                placeholder="Enter your password"
                value={signupInfo.password}
                onChange={handleChange}
                className="password-input"
                autoComplete="new-password"
              />
              <img
                src={showPassword ? visibilityIcon : HiddenIcon}
                alt="Toggle visibility"
                className="eye-icon"
                onClick={() => setShowPassword(p => !p)}
              />
            </div>
            {passwordError && <p className="error">{passwordError}</p>} 

            <label htmlFor="confirmPassword">Confirm Password</label>
            <div className="cpassword-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Re-enter your password"
                value={signupInfo.confirmPassword}
                onChange={handleChange}
                className="password-input"
                autoComplete="new-password"
              />
              <img
                src={showConfirmPassword ? visibilityIcon : HiddenIcon}
                alt="Toggle visibility"
                className="eye-iconn"
                onClick={() => setShowConfirmPassword(p => !p)}
              />
            </div>

            <div className="action-row">
              <div className="remember">
                <input type="checkbox" id="remember" />
                <span>Remember me</span>
              </div>

            <button type="submit" className="submit-btn">
              Signup
            </button>
            </div>
          
        <p className="switch-text">
            Already have an account?{' '}
            <Link to='/login' className="link"><span>Login</span></Link>
          </p>
    
              <div className="divider">
                <hr /><span>or</span><hr />
              </div>
    
              <p className="login-with">Login with</p>
              <div className="social-buttons">
                <button
                  className="social google"
                  type="button"
                  onClick={() => window.location.href = 'https://accounts.google.com'}
                >
                  <img
                    src="https://img.icons8.com/color/48/000000/google-logo.png"
                    alt="Google"
                    style={{ height: '24px' }}
                  />
                  Google
                </button>
              </div>
          
        </form>
        </div>
        <div className="form-right">
          <img src={loginimage} alt="Side visual" />
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}